import React from "react";
import { CASINO_CONFIG_PATH } from "utils/constants/paths";
import { IRouteItem, Loadable } from "@techzyapp/ui-lib";

const CasinoConfig = Loadable(React.lazy(() => import("./View")));

export const CasinoConfigRoute: IRouteItem = {
  path: CASINO_CONFIG_PATH,
  iconName: "Crown1",
  element: React.createElement(CasinoConfig),
  name: "Casino Config",
  accessKeys: ["SuperAdmin", "Admin"],
};
